import { userAgentIsSSR } from "../utils/userAgent";
import { useScript } from "./useScript";

export const useZendesk = (isAuthModalOpen, showTabBar, backToTopPosition) => {
  if (userAgentIsSSR()) return;

  const zendeskScriptUrl =
    "https://v2.zopim.com/?4L2L98iTNdVwnVP2uZbfeMJTewy6xD9K";

  const attributes = {
    async: true,
    charset: "utf-8",
    type: "text/javascript",
  };

  const onLoad = () => {
    const baseOffset = showTabBar ? 60 : 0;
    const verticalOffset = baseOffset + (backToTopPosition || 0);

    window.zESettings = {
      webWidget: {
        offset: {
          horizontal: "0px",
          vertical: `${verticalOffset}px`,
          mobile: {
            horizontal: "-8px",
            vertical: `${verticalOffset}px`,
          },
        },
      },
    };
  };

  useScript(zendeskScriptUrl, attributes, isAuthModalOpen, onLoad);
};
